import { FORWARD_EMAIL_COMMUNICATION, FORWARD_EMAIL_COMMUNICATION_SUCCESS, FORWARD_EMAIL_COMMUNICATION_ERROR, FORWARD_EMAIL_COMMUNICATION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ForwardEmailCommunication = (state = initialState, action) => {
  switch (action.type) {
    case FORWARD_EMAIL_COMMUNICATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case FORWARD_EMAIL_COMMUNICATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case FORWARD_EMAIL_COMMUNICATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case FORWARD_EMAIL_COMMUNICATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ForwardEmailCommunication;
